export default __webpack_public_path__ + "static/media/five.79ee61bc.svg";